import React from "react";
import { useParams } from "react-router-dom";
import MasterLayout from "../../masterLayout/MasterLayout";
import Breadcrumb from "../../components/Breadcrumb";
import ViewBookingPageNew from "../../components/Booking/ViewBookingPageNew";

const ViewUserBookingPage = () => {
  // ✅ grab both id and userid from route
  const { id, userid } = useParams();

  return (
    <MasterLayout>
      {/* Breadcrumb */}
      <Breadcrumb
        id="title"
        title2="User Management"
        link2="/user"
        title3="User Detail"
        link3={`/user/view-user/${userid}`} // ✅ link3 should include userid
        title="View Booking"
      />

      {/* Pass props down */}
      <ViewBookingPageNew roles="user" bookingId={id} userId={userid} />
    </MasterLayout>
  );
};

export default ViewUserBookingPage;
